export const AUTHORCHANGED = "filter/authorChanged";
export const CATEGORYCHANGED = "filter/categoryChanged";
export const SEARCH = "filter/search";
export const CLEAR = "filter/clear";
export const CLEARSEARCH = "filter/clearSearch";
export const CLEARCATEGORY = "filter/clearCategory";
export const CLEARAUTHOR = "filter/clearAuthor";
